import script from "./FilterMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterMobile.vue?vue&type=script&setup=true&lang=js"

import "./FilterMobile.vue?vue&type=style&index=0&id=044ad77e&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-044ad77e"]])

export default __exports__